<template>
  <div>
    <PrenotazioniDesktop v-if="!$vuetify.breakpoint.mobile" />
    <PrenotazioniMobile v-else />
  </div>
</template>

<script>
import PrenotazioniDesktop from "@/components/Prenotazioni/desktop/PrenotazioniDesktop.vue";
import PrenotazioniMobile from "@/components/Prenotazioni/mobile/PrenotazioniMobile.vue";

export default {
  name: "Prenotazioni",
  components: { PrenotazioniDesktop, PrenotazioniMobile },
};
</script>
